import { Autocomplete } from '@/components/inputs/Autocomplete'

import { FilterType, LoadMoreOptions } from '../../base/FilterableTable/FilterableTable.types'

type Props = {
  label: string
  options: FilterType[]
  listBoxWidth?: number | string
  width?: number | string
  onFilterSelect: (value: FilterType | null) => void
  selectedOption: FilterType
  loadMoreOptions?: LoadMoreOptions
}

const TOURNAMENT_PROPERTY_AUTOCOMPLETE_TEST_ID = 'tournament-property-autocomplete-test-id'

export const AutocompleteFilter = ({
  options,
  label,
  onFilterSelect,
  width,
  selectedOption,
  listBoxWidth,
  loadMoreOptions
}: Props) => {
  const { loadMoreCallback, loading, pagination } = loadMoreOptions || {}

  return (
    <Autocomplete
      options={options.filter((opt) => opt.value !== selectedOption?.value)}
      label={label}
      value={null}
      loadMoreOptions={loadMoreCallback}
      pagination={pagination}
      loading={loading}
      testId={TOURNAMENT_PROPERTY_AUTOCOMPLETE_TEST_ID}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label || ''}
      listBoxWidth={listBoxWidth}
      width={width}
      onClear={() => {
        onFilterSelect(null)
      }}
      filterOptions={(options, state) =>
        options.filter((option) =>
          option.label?.toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
      fullWidth={false}
      onChange={(value) => {
        if (value) {
          onFilterSelect(value)
        }
      }}
    />
  )
}
